/**
 * Keep-fees-and-bonuses is a child of the two waivers: it only means anything
 * while at least one waiver is on. Every reader and writer of the flag should
 * resolve it through here so a stale child cannot re-arm itself when a
 * different parent is turned on later.
 */
export function resolveKeepFeesAndBonuses({
  waiveOutstandingBalance,
  waiveCustomerCompensation,
  keepFeesAndBonuses,
}: {
  waiveOutstandingBalance: boolean;
  waiveCustomerCompensation: boolean;
  keepFeesAndBonuses: boolean;
}): boolean {
  return (
    (waiveOutstandingBalance || waiveCustomerCompensation) && keepFeesAndBonuses
  );
}

interface ReturnWaiverFlags {
  waiveDraftFee?: boolean | null;
  waiveCustomerCompensation?: boolean | null;
  keepFeesAndBonuses?: boolean | null;
}

/**
 * Whether a created return's outstanding balance is forgiven outright. Keeping
 * fees and bonuses leaves them owed, so the balance still gets collected.
 */
export function isOutstandingBalanceFullyWaived({
  options,
  processingInput,
}: {
  options?: ReturnWaiverFlags | null;
  processingInput?: ReturnWaiverFlags | null;
}): boolean {
  const waiveOutstandingBalance = !!(
    options?.waiveDraftFee || processingInput?.waiveDraftFee
  );
  const keepingFeesAndBonuses = resolveKeepFeesAndBonuses({
    waiveOutstandingBalance,
    waiveCustomerCompensation: !!(
      options?.waiveCustomerCompensation ||
      processingInput?.waiveCustomerCompensation
    ),
    keepFeesAndBonuses: !!(
      options?.keepFeesAndBonuses || processingInput?.keepFeesAndBonuses
    ),
  });
  return waiveOutstandingBalance && !keepingFeesAndBonuses;
}
